module.exports = __webpack_public_path__ + "img/28.fe88c535.png";